/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * RETIRE — the version in force retired with nothing in its place: retiring questions, one or many, or a new version that does not keep the current one. SET_CATEGORY — the questions moved to categoryId. ACTIVATE_VERSION — versionId put in force for the one question named; its wording in the language it was written in is approved on the way, as activation does. SET_POSITIONS — the questions given to every position, or to the positions listed instead of their own.
 * @export
 * @enum {string}
 */

export const PlannedChangeKindDto = {
    Retire: 'RETIRE',
    SetCategory: 'SET_CATEGORY',
    ActivateVersion: 'ACTIVATE_VERSION',
    SetPositions: 'SET_POSITIONS'
} as const;

export type PlannedChangeKindDto = typeof PlannedChangeKindDto[keyof typeof PlannedChangeKindDto];



